<template>
  <div
    v-show="getAdvExpoflag == true"
    :class="
      !mobileView ? 'expo-hall-wrap-hld' : 'hall-top-area substitute-page-wrap'
    "
    style="background: white"
    @click="onClickHandler"
  >
    <!--class="page-effect" -->
    <div v-show="!mobileView" class="expo-top-wrapper">
      <div class="container-fluid">
        <div
          class="
            row
            new-addendee-list
            bg-transparent
            d-flex
            align-items-center
            px-4
            my-0
          "
        >
          <div class="col-md-6 mb-md-0">
            <h1 id="headerText" class="page-head text-uppercase mb-0">
              {{ headerText }}
            </h1>
          </div>
          <!-- <div class="col-md-8">
            <div class="right-side-hld d-flex align-items-center justify-content-end">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="exampleInputEmail1">You're viewing</label>
                  <select v-on:change="onChange($event)">
                    <option
                      v-for="topics in roundtableTopicData"
                      v-bind:key="topics.id"
                      :value="topics.id"
                      data-tag="roundtableFilter"
                    >{{topics.TopicName}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>-->
          <div class="col-md-2" v-if="types.length > 2">
            <div class="expo-listing-type-dropdown">
              <v-select
                v-if="types"
                :items="types"
                :item-text="'TypeName'"
                :item-value="'TypeName'"
                label="Select Exhibitor Type"
                dense
                solo
                height="45px"
                v-model="exhibitorType"
                @change="updateBGImageByType(exhibitorType)"
              ></v-select>
            </div>
          </div>
          <div :class="types.length > 2 ? 'col-md-4' : 'col-md-6 mb-md-0'">
            <div class="row justify-content-end" id="dvFilter">
              <div
                :class="
                  types.length > 2
                    ? 'col-md-12 mb-3 mb-md-0 pr-1'
                    : 'col-md-10 mb-3 mb-md-0 pr-1'
                "
              >
                <div class="right-search-hld">
                  <div class="position-relative fixed-w full-width search-hld">
                    <form
                      id="newsletter-validate-detail"
                      action
                      method
                      class="form subscribe"
                    >
                      <!-- <input
                        id="InputSearch"
                        @keyup="searchExhibitors"
                        type="text"
                        placeholder="Search by Name or Keywords...  "
                        v-model="searchtext"
                        onkeydown="return (event.keyCode!=13);"
                        data-tag="exhibitorsSearch"
                      />-->

                      <input
                        id="InputSearch"
                        type="text"
                        @keyup="searchExhibitors2"
                        v-on:keydown.enter.prevent="searchExhibitors2"
                        v-model="searchtext"
                        :placeholder="$t('expo.searchtext')"
                      />

                      <!-- <button
                        id="btnCancel"
                        v-on:click="cancelSearch()"
                        type="button"
                        class="sub-btn cross"
                        v-show="IsShowCancelButton"
                        data-tag="exhibitorsearchcancel"
                      >&nbsp;</button>
                      <button
                        id="btnSearch"
                        v-on:click="searchExhibitors()"
                        class="sub-btn"
                        type="button"
                        data-tag="attendeeSearchSubmit"
                      >Search</button>-->
                    </form>
                    <div class="reset-search-btn">
                      <p
                        v-if="searchtext"
                        @click="
                          searchtext = '';
                          searchExhibitors2();
                        "
                      >
                        <v-icon dark small color="#8a8a8a">mdi-close</v-icon>
                      </p>
                    </div>
                  </div>
                  <a href="javascript:void(0);" @click="searchExhibitors2"
                    >GO</a
                  >
                </div>
              </div>

              <div id="dvFiltermain" class="col-md-4 mb-3 mb-md-0 pl-1">
                <div
                  class="position-relative fixed-w full-width filter-hld"
                  id="dvSelFilter"
                >
                  <select v-on:change="getExhibitors" id="selFilter">
                    <option
                      v-bind:key="item.id"
                      :id="item.id"
                      v-for="item in DropFilter"
                    >
                      {{ item.value }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-show="!mobileView"
      :class="!mobileView ? 'page-effect expo-wrapper-sec' : 'd-none'"
    >
      <div class="exporight-panel">
        <v-btn raised color="rgba(0,0,0,0.7)" width="45px" min-width="45px" height="40px" class="mb-2 expo-panel-butn"><img src="../../assets/Images/new-design-icons/booth-list.svg" style="height: 25px; width: 25px;"/></v-btn>
        <v-btn raised color="rgba(0,0,0,0.7)" width="45px" min-width="45px" height="40px" class="mb-2 expo-panel-butn" @click="templateListDialog()"><img src="../../assets/Images/new-design-icons/template.svg" style="height: 25px; width: 25px;"/></v-btn>
      </div>
      <div
        v-if="allowRequestMeetingInExpoHall"
        class="businesscard-exchange-wrapper"
      >
        <!--<div class="exchange-card-section">
          <p id="btnBusinessCard" @click="openSchedulePopup()">
            {{ $t("mymeetings.bookmeeting") }}
          </p>
        </div>-->
        <button
          id="btnOpenRequestMeeting"
          class="btn meeting-request mt-1 border-stranprent border-tranprent"
          @click="openSchedulePopup('')"
        >
          BOOK APPOINTMENT
        </button>
      </div>
      <v-btn
        color="#fff"
        fab
        small
        @keyup.left="getPrvLot"
        v-on:click.prevent="getPrvLot"
        v-if="exCount > 7 && stRange != 0"
        class="exhibitorHallLeftArrow"

      >
        <v-icon color="#000000" size="28px">mdi-chevron-left</v-icon>
       
        <!-- <span>{{ $t("expo.prev") }}</span> -->
      </v-btn>
      <v-btn
        color="#fff"
        fab
        small
        @keyup.right="getNextLot"
        v-on:click.prevent="getNextLot"
        v-if="exCount > 7 && endRange != totalCount"
        class="exhibitorHallRightArrow"
      >
         <v-icon color="#000000" size="28px">mdi-chevron-right</v-icon>
        <!-- <span>{{ $t("expo.nxt") }}</span> -->
      </v-btn>
      <img :src="ExpoHallBackgroundImage" alt="" />

      <!-- <transition :name="transitionType"> -->
      <div class="custom-booths-container" v-if="show">
        <div
          class="single-booth page-effect"
          v-bind:id="item.id"
          v-bind:key="item.id"
          v-for="(item, index) in getFilteredExhibitorList.slice(
            stRange,
            endRange
          )"
        >
          <a
            href="#"
            @click.prevent="showtooltip(item.id, item)"
            v-if="showTooltips == true"
            :id="item.id + '_open'"
          >
            <img src="../../assets/Images/booth-base.png" />
            <div class="booth-logo">
              <img :src="item.Logo" alt="Loading..." />
            </div>
            <div class="booth-thumb">
              <img
                :src="item.HotspotImageUrL"
                style="width: 100%; position: relative"
                alt="Loading..."
              />
            </div>
          </a>
          <a
            href="#"
            @click.prevent="openBooth(item)"
            :id="item.id + '_close'"
            v-else
          >
            <img src="../../assets/Images/booth-base.png" />
            <div class="booth-logo">
              <img :src="item.Logo" alt="Loading..." />
            </div>
            <div class="booth-thumb">
              <img
                :src="item.HotspotImageUrL"
                style="width: 100%; position: relative"
                alt="Loading..."
              />
            </div>
          </a>
          <div
            v-if="
              index + 1 <
              getFilteredExhibitorList.slice(stRange, endRange).length / 2
            "
            :id="'infotoolTip' + item.id"
            class="custom-tool-tip-right"
          >
            <div class="new-expo-tooltipinner-wrap">
              <div class="new-tool-tiphead">
                <div class="head-left">
                  <h3
                    style="
                      font-size: 18px !important;
                      font-weight: 600;
                      color: #333;
                      margin: 0;
                      cursor: pointer;
                    "
                    @click.prevent="loadView(item.id, item.Name)"
                    :data-tag="'exhibitorview/' + item.id + '/' + item.Name"
                  >
                    {{ item.Name
                    }}<span class="pl-3">
                      <v-tooltip
                        v-if="!item.isBookmarked && !item.isBookmarkLoading"
                        bottom
                      >
                        <template v-slot:activator="{ on }">
                          <v-icon
                            size="32"
                            color="black"
                            @click.stop="
                              addBookMark(item.id, item.Name, item.Logo)
                            "
                            style="cursor: pointer"
                            v-on="on"
                            >bookmark_border</v-icon
                          >
                        </template>
                        <span>Bookmark</span>
                      </v-tooltip>
                      <v-tooltip
                        v-else-if="item.isBookmarked && !item.isBookmarkLoading"
                        bottom
                      >
                        <template v-slot:activator="{ on }">
                          <v-icon
                            size="32"
                            color="success"
                            @click.stop="
                              addBookMark(item.id, item.Name, item.Logo)
                            "
                            style="cursor: pointer"
                            v-on="on"
                            >bookmark</v-icon
                          >
                        </template>
                        <span>Bookmarked</span>
                      </v-tooltip>
                      <v-btn
                        v-show="item.isBookmarkLoading"
                        :loading="item.isBookmarkLoading"
                        outlined
                        style="border: 0"
                        min-width="0"
                        class="tool-tip-loader"
                      ></v-btn>
                    </span>
                  </h3>
                </div>
                        <div class="tool-tip-social-ico">
                    <ul class="d-flex justify-content-end align-items-center">
                      <li v-for="links in item.SocialLinks" :key="links.key">
                        <a
                          v-if="links.value && links.key == 'Facebook'"
                          target="_blank"
                          :href="links.value"
                          :data-tag="
                            'Facebook -' + item.Name + '-' + links.value
                          "
                          style="
                            height: 30px;
                            width: 30px;
                            background: #046ee5;
                            display: inline-block;
                            text-align: center;
                            border-radius: 50%;
                            line-height: 30px;
                            margin: 0 5px;
                          "
                        >
                          <img
                            style="height: 20px; width: 20px"
                            :data-tag="
                              'Facebook -' + item.Name + '-' + links.value
                            "
                            src="../../assets/Images/facebook.svg"
                          />
                        </a>
                        <a
                          v-else-if="links.value && links.key == 'Twitter'"
                          target="_blank"
                          :href="links.value"
                          :data-tag="
                            'Twitter -' + item.Name + '-' + links.value
                          "
                          style="
                            height: 30px;
                            width: 30px;
                            background: #046ee5;
                            display: inline-block;
                            text-align: center;
                            border-radius: 50%;
                            line-height: 30px;
                            margin: 0 5px;
                          "
                        >
                          <img
                            style="height: 20px; width: 20px"
                            :data-tag="
                              'Twitter -' + item.Name + '-' + links.value
                            "
                            src="../../assets/Images/twitter.svg"
                          />
                        </a>
                        <a
                          v-else-if="links.value && links.key == 'LinkedIn'"
                          target="_blank"
                          :href="links.value"
                          :data-tag="
                            'LinkenIn -' + item.Name + '-' + links.value
                          "
                          style="
                            height: 30px;
                            width: 30px;
                            background: #046ee5;
                            display: inline-block;
                            text-align: center;
                            border-radius: 50%;
                            line-height: 25px;
                            margin: 0 5px;
                          "
                        >
                          <img
                            style="height: 20px; width: 20px"
                            :data-tag="
                              'LinkenIn -' + item.Name + '-' + links.value
                            "
                            src="../../assets/Images/linkedin_new.svg"
                          />
                        </a>
                        <a
                          v-else-if="links.value && links.key == 'GooglePlus'"
                          target="_blank"
                          :href="links.value"
                          :data-tag="
                            'Instagram -' + item.Name + '-' + links.value
                          "
                          style="
                            height: 30px;
                            width: 30px;
                            background: #046ee5;
                            display: inline-block;
                            text-align: center;
                            border-radius: 50%;
                            line-height: 25px;
                            margin: 0 5px;
                          "
                        >
                          <img
                            style="height: 20px; width: 20px"
                            :data-tag="
                              'Instagram -' + item.Name + '-' + links.value
                            "
                            src="../../assets/Images/instagram.svg"
                          />
                        </a>
                      </li>
                    </ul>
                  </div>
              </div>
              <div class="tool-tip-desc-info-box">
                <p
                  style="
                    font-size: 14px !important;
                    font-weight: 400;
                    color: #333;
                    line-height: 18px;
                    margin: 0 0 20px;
                  "
                >
                  <span v-html="item.Profile"></span>
                  <a
                    :data-tag="'exhibitorview/' + item.id + '/' + item.Name"
                    @click.prevent="loadView(item.id, item.Name)"
                    style="
                      font-weight: bold;
                      color: #0c1de7 !important;
                      text-decoration: none;
                    "
                    >{{ $t("expo.enterbooth") }} >></a
                  >
                </p>
                <ul>
                  <li>
                    <a
                      v-if="item.Email !== ''"
                      :href="'mailto:' + item.Email"
                      :data-tag="'Email -' + item.Name + '-' + item.Email"
                      target="_blank"
                      style="
                        display: inline-block;
                        font-size: 16px;
                        font-weight: 400;
                        color: #333;
                        margin-right: 20px;
                      "
                    >
                      <img
                        style="height: 20px; width: 20px"
                        src="../../assets/Images/envelope.svg"
                        :data-tag="'Email -' + item.Name + '-' + item.Email"
                      />
                      {{ item.Email }}
                    </a>
                  </li>
                  <li>
                    <a
                      v-if="item.Phone !== ''"
                      :href="'tel:' + item.Phone"
                      :data-tag="'Phone -' + item.Name + '-' + item.Phone"
                      style="
                        display: inline-block;
                        font-size: 16px;
                        font-weight: 400;
                        color: #333;
                        margin-right: 20px;
                      "
                    >
                      <img
                        style="height: 20px; width: 20px"
                        src="../../assets/Images/contact.svg"
                        :data-tag="'Phone -' + item.Name + '-' + item.Phone"
                      />
                      {{ item.Phone }}
                    </a>
                  </li>
                  <li>
                    <a
                      v-if="item.Website !== ''"
                      target="_blank"
                      :href="item.Website"
                      :data-tag="'Website -' + item.Name + '-' + item.Website"
                      style="
                        display: inline-block;
                        font-size: 16px;
                        font-weight: 400;
                        color: #333;
                        margin-right: 20px;
                      "
                    >
                      <img
                        style="height: 20px; width: 20px"
                        src="../../assets/Images/web.svg"
                        :data-tag="'Website -' + item.Name + '-' + item.Website"
                      />
                      {{ item.Website }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="cross-btn-wrap">
              <button v-on:click.prevent="closetooltip(item.id)">X</button>
            </div>
          </div>
          <div
            v-if="
              index + 1 >=
              getFilteredExhibitorList.slice(stRange, endRange).length / 2
            "
            :id="'infotoolTip' + item.id"
            class="custom-tool-tip-left"
          >
            <div class="new-expo-tooltipinner-wrap">
              <div class="new-tool-tiphead">
                <div class="head-left">
                  <h3
                    style="
                      font-size: 18px !important;
                      font-weight: 600;
                      color: #333;
                      margin: 0;
                      cursor: pointer;
                    "
                    @click.prevent="loadView(item.id, item.Name)"
                    :data-tag="'exhibitorview/' + item.id + '/' + item.Name"
                  >
                    {{ item.Name }}
                    <span class="pl-3">
                      <v-tooltip
                        v-if="!item.isBookmarked && !item.isBookmarkLoading"
                        bottom
                      >
                        <template v-slot:activator="{ on }">
                          <v-icon
                            size="32"
                            color="black"
                            @click.stop="
                              addBookMark(item.id, item.Name, item.Logo)
                            "
                            style="cursor: pointer"
                            v-on="on"
                            >bookmark_border</v-icon
                          >
                        </template>
                        <span>Bookmark</span>
                      </v-tooltip>
                      <v-tooltip
                        v-else-if="item.isBookmarked && !item.isBookmarkLoading"
                        bottom
                      >
                        <template v-slot:activator="{ on }">
                          <v-icon
                            size="32"
                            color="success"
                            @click.stop="
                              addBookMark(item.id, item.Name, item.Logo)
                            "
                            style="cursor: pointer"
                            v-on="on"
                            >bookmark</v-icon
                          >
                        </template>
                        <span>Bookmarked</span>
                      </v-tooltip>
                      <v-btn
                        v-show="item.isBookmarkLoading"
                        :loading="item.isBookmarkLoading"
                        outlined
                        style="border: 0"
                        min-width="0"
                        class="tool-tip-loader"
                      ></v-btn>
                    </span>
                  </h3>
                </div>
                <div class="tool-tip-social-ico">
                  <ul>
                    <li
                      :data-tag="
                        'Facebook -' +
                        item.Name +
                        '-' +
                        item.SocialLinks[0].value
                      "
                      v-if="
                        item.SocialLinks[0].value != undefined &&
                        item.SocialLinks[0].value != ''
                      "
                    >
                      <a
                        target="_blank"
                        :href="item.SocialLinks[0].value"
                        :data-tag="
                          'Facebook -' +
                          item.Name +
                          '-' +
                          item.SocialLinks[0].value
                        "
                        style="
                          height: 30px;
                          width: 30px;
                          background: #046ee5;
                          display: inline-block;
                          text-align: center;
                          border-radius: 50%;
                          line-height: 30px;
                          margin: 0 5px;
                        "
                      >
                        <img
                          style="height: 20px; width: 20px"
                          src="../../assets/Images/facebook.svg"
                          :data-tag="
                            'Facebook -' +
                            item.Name +
                            '-' +
                            item.SocialLinks[0].value
                          "
                        />
                      </a>
                    </li>
                    <li
                      v-if="
                        item.SocialLinks[3].value != undefined &&
                        item.SocialLinks[3].value != ''
                      "
                      :data-tag="
                        'Twitter -' +
                        item.Name +
                        '-' +
                        item.SocialLinks[3].value
                      "
                    >
                      <a
                        target="_blank"
                        :href="item.SocialLinks[3].value"
                        :data-tag="
                          'Twitter -' +
                          item.Name +
                          '-' +
                          item.SocialLinks[3].value
                        "
                        style="
                          height: 30px;
                          width: 30px;
                          background: #046ee5;
                          display: inline-block;
                          text-align: center;
                          border-radius: 50%;
                          line-height: 30px;
                          margin: 0 5px;
                        "
                      >
                        <img
                          style="height: 20px; width: 20px"
                          src="../../assets/Images/twitter.svg"
                          :data-tag="
                            'Twitter -' +
                            item.Name +
                            '-' +
                            item.SocialLinks[3].value
                          "
                        />
                      </a>
                    </li>
                    <li
                      :data-tag="
                        'LinkedIn -' +
                        item.Name +
                        '-' +
                        item.SocialLinks[2].value
                      "
                      v-if="
                        item.SocialLinks[2].value != undefined &&
                        item.SocialLinks[2].value != ''
                      "
                    >
                      <a
                        target="_blank"
                        :data-tag="
                          'LinkedIn -' +
                          item.Name +
                          '-' +
                          item.SocialLinks[2].value
                        "
                        :href="item.SocialLinks[2].value"
                        style="
                          height: 30px;
                          width: 30px;
                          background: #046ee5;
                          display: inline-block;
                          text-align: center;
                          border-radius: 50%;
                          line-height: 25px;
                          margin: 0 5px;
                        "
                      >
                        <img
                          :data-tag="
                            'LinkedIn -' +
                            item.Name +
                            '-' +
                            item.SocialLinks[2].value
                          "
                          style="height: 20px; width: 20px"
                          src="../../assets/Images/linkedin_new.svg"
                        />
                      </a>
                    </li>
                    <li
                      :data-tag="
                        'Instagram -' +
                        item.Name +
                        '-' +
                        item.SocialLinks[1].value
                      "
                      v-if="
                        item.SocialLinks[1].value != undefined &&
                        item.SocialLinks[1].value != ''
                      "
                    >
                      <a
                        target="_blank"
                        :data-tag="
                          'Instagram -' +
                          item.Name +
                          '-' +
                          item.SocialLinks[1].value
                        "
                        :href="item.SocialLinks[1].value"
                        style="
                          height: 30px;
                          width: 30px;
                          background: #046ee5;
                          display: inline-block;
                          text-align: center;
                          border-radius: 50%;
                          line-height: 25px;
                          margin: 0 5px;
                        "
                      >
                        <img
                          :data-tag="
                            'Instagram -' +
                            item.Name +
                            '-' +
                            item.SocialLinks[1].value
                          "
                          style="height: 20px; width: 20px"
                          src="../../assets/Images/instagram.svg"
                        />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="tool-tip-desc-info-box">
                <p
                  style="
                    font-size: 14px !important;
                    font-weight: 400;
                    color: #333;
                    line-height: 18px;
                    margin: 0 0 20px;
                  "
                >
                  <span v-html="item.Profile"></span>
                  <a
                    @click.prevent="loadView(item.id, item.Name)"
                    :data-tag="'exhibitorview/' + item.id + '/' + item.Name"
                    style="
                      font-weight: bold;
                      color: #0c1de7 !important;
                      text-decoration: none;
                    "
                    >{{ $t("expo.enterbooth") }} >></a
                  >
                </p>
                <ul>
                  <li>
                    <a
                      :href="'mailto:' + item.Email"
                      :data-tag="'Email -' + item.Name + '-' + item.Email"
                      target="_blank"
                      style="
                        display: inline-block;
                        font-size: 16px;
                        font-weight: 400;
                        color: #333;
                        margin-right: 20px;
                      "
                    >
                      <img
                        style="height: 20px; width: 20px"
                        src="../../assets/Images/envelope.svg"
                        :data-tag="'Email -' + item.Name + '-' + item.Email"
                      />
                      {{ item.Email }}
                    </a>
                  </li>
                  <li>
                    <a
                      :href="'tel:' + item.Phone"
                      :data-tag="'Phone -' + item.Name + '-' + item.Phone"
                      style="
                        display: inline-block;
                        font-size: 16px;
                        font-weight: 400;
                        color: #333;
                        margin-right: 20px;
                      "
                    >
                      <img
                        style="height: 20px; width: 20px"
                        src="../../assets/Images/contact.svg"
                        :data-tag="'Phone -' + item.Name + '-' + item.Phone"
                      />
                      {{ item.Phone }}
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      :href="item.Website"
                      :data-tag="'Website -' + item.Name + '-' + item.Website"
                      style="
                        display: inline-block;
                        font-size: 16px;
                        font-weight: 400;
                        color: #333;
                        margin-right: 20px;
                      "
                    >
                      <img
                        style="height: 20px; width: 20px"
                        src="../../assets/Images/web.svg"
                        :data-tag="'Website -' + item.Name + '-' + item.Website"
                      />
                      {{ item.Website }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="cross-btn-wrap">
              <button v-on:click.prevent="closetooltip(item.id)">X</button>
            </div>
          </div>
        </div>
      </div>
      <!-- </transition> -->

      <!-- </div> -->
    </div>
    <!-- No dat Found -->
    <div v-show="IsShowNoDataFound && !mobileView" style="text-align: center">
      <h2 style="text-align: center; margin-top: 60px">
        {{ $t("expo.nodata") }}
      </h2>
      <!-- <button
            id="btnNewSearch"
            v-on:click="cancelSearch()"
            class="blue-button"
            type="button"
            style="text-align:center;margin-top: 60px;"
            data-tag="attendeeNewSearch"
      >Start new search</button>-->
    </div>

    <div v-show="mobileView" class="container grey-bg py-5">
      <div class="hall-top-area-inner">
        <div
          class="d-flex align-items-center justify-content-between mob-full"
          style="width: 100%"
        >
          <h1 id="headerText" class="page-head text-uppercase mb-md-5 mb-0">
            {{ headerText }}
          </h1>
          <div class="d-flex align-items-center">
            <!-- mobile search button -->
            <div class="d-block d-md-none mr-2">
              <button
                class="mob_search_button"
                v-on:click="mob_spelist_search()"
              >
                <img
                  src="../../assets/Images/icons/search-black.svg"
                  alt="e2m"
                  width="20px"
                />
              </button>
            </div>
            <!-- mobile search button end -->
            <div class="hall-view-btn">
              <img
                src="../../assets/Images/grid-view-dark.svg"
                class="grid-dark"
                v-on:click="hallGridView"
              />
              <img
                src="../../assets/Images/list-dark.svg"
                class="list-dark"
                v-on:click="hallListView"
              />
            </div>
          </div>
        </div>
        <div class="hall-top-right d-none">
          <div class="right-search-hld">
            <div class="search-hall">
              <input
                type="text"
                name=""
                id=""
                value=""
                placeholder="Search"
                @keyup="searchExhibitors2"
                v-on:keydown.enter.prevent="searchExhibitors2"
                v-model="searchtext"
              />
            </div>
            <a href="javascript:void(0)" @click="searchExhibitors2">GO</a>
          </div>
        </div>
      </div>
    </div>
    <div v-show="mobileView" class="hall-booth-inner-wrap">
      <div class="container">
        <div class="row">
          <div
            class="col-md-6 single-hall-booth-wrap"
            v-bind:id="item.id"
            v-bind:key="item.id"
            v-for="item in Exhibitorlist"
          >
          
            <div
              class="single-booth"
              @click.prevent="loadView(item.id, item.Name)"
              :data-tag="'exhibitorview/' + item.id + '/' + item.Name"
            >
              <div class="booth-image">
                <img :src="item.Logo" alt="Loading..." />
              </div>
              <div
                class="
                  booth-description
                  d-flex
                  justify-content-between
                  align-items-center
                  full-width
                "
              >
                <p>{{ item.Name }}</p>
                <span class="bookmark-icon ml-2">
                  <v-icon
                    v-if="!item.isBookmarked && !item.isBookmarkLoading"
                    size="36"
                    color="#cccccc"
                    style="cursor: pointer"
                    @click.stop="addBookMark(item.id, item.Name, item.Logo)"
                    >bookmark_border</v-icon
                  >
                  <v-icon
                    v-if="item.isBookmarked && !item.isBookmarkLoading"
                    size="36"
                    color="success"
                    style="cursor: pointer"
                    @click.stop="addBookMark(item.id, item.Name, item.Logo)"
                    >bookmark</v-icon
                  >
                  
                  <v-btn
                    v-show="item.isBookmarkLoading"
                    :loading="item.isBookmarkLoading"
                    outlined
                    style="border: 0"
                    min-width="0"
                    class="tool-tip-loader"
                  ></v-btn>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button
      v-if="mobileView && allowRequestMeetingInExpoHall"
      id="btnOpenRequestMeeting"
      class="btn meeting-request mt-1 border-stranprent border-tranprent"
      @click="openSchedulePopup('')"
    >
      BOOK APPOINTMENT
    </button>
    <!-- No dat Found ENDS-->

    <v-dialog
      ref="exMeeting"
      v-model="dialog"
      content-class="client-dialog-exhibitors rounded-lg"
      transition="scroll-x-reverse-transition"
      width="auto"
    >
      <v-card class="rounded-lg" style="overflow: hidden">
        <!-- <v-toolbar
          class="pl-8"
          color="primary"
          style="box-shadow: none; background-color: #fff !important"
        >
          <v-toolbar-title
            class="text-h5 ml-2 mt-6"
            style="color: #000; font-weight: 500"
          >
            Appointment
          </v-toolbar-title>
          <v-spacer></v-spacer>
          
        </v-toolbar> -->
        <!--<v-card-title>
          <div style="position: absolute; right: 10px; top: 10px">
            Book Appointment
          </div>
        </v-card-title>-->
        <v-card-text
          id="ClientLobbyCard"
          class="ex-dialog-body px-0 mt-0 position-relative rounded-lg"
          style="p-0;font-size:1rem"
        >
          <div style="position: absolute; right: 0px; top: 0px">
            <v-icon style="z-index: 2" size="32" @click="closeHandler()"
              >close</v-icon
            >
          </div>
          <div class="apointment-pop-hld" style="width: 100%">
            <v-tabs v-model="tab" align-with-title>
              <v-tabs-slider color="black"></v-tabs-slider>
              <v-tab
                v-if="allowRequestMeeting"
                id="tabExhibitorsSchedule"
                href="#schedule"
                style="margin-left: 0"
                @click="openSchedulePopup('/mymeetings')"
                class="tab-top first-tab"
                >Book Appointment
              </v-tab>
              <v-tab
                href="#meeting"
                style="margin-left: 0"
                @click="openSchedulePopup('/mymeetings')"
                class="tab-top"
                >Confirmed Meetings
              </v-tab>
              <v-tab-item
                v-if="allowRequestMeeting"
                value="schedule"
                class="tab-content"
              >
                <Exhibitors
                  :Exhibitorlist="Exhibitorlist"
                  @OpenRequestMeeting="OpenRequestMeeting($event)"
                ></Exhibitors>
              </v-tab-item>
              <v-tab-item value="meeting" class="tab-content">
                <ExhibitorsMeeting
                  :uid="uid"
                  :allowRequestMeeting="allowRequestMeeting"
                  @goToBookAppointment="goToBookAppointment"
                ></ExhibitorsMeeting>
                <!--<router-view></router-view>-->
                <!--<v-card flat>
									<v-card-text v-text="text"></v-card-text>
								</v-card>-->
              </v-tab-item>
            </v-tabs>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="templateList"
      width="900px"
    >
      <v-card class="p-3">
        <div class="dialog-header d-flex justify-content-between align-items-center">
          <h3>Change Background</h3>
          <v-btn elevation="3" color="#fff" fab small @click="templateList = false">
            <v-icon color="#000000" size="25px">mdi-close</v-icon> 
          </v-btn>
        </div>
        <template>
          <v-tabs v-model="tab2" align-with-title class="template-tabs-head">
            <v-tabs-slider color="#000"></v-tabs-slider>
            <v-tab class="ml-0">Gallery</v-tab>
            <v-tab>Upload</v-tab>
            <v-tab>Link to Image</v-tab>
          </v-tabs>
        </template>
        <v-tabs-items v-model="tab2">
          <v-tab-item>
            <div class="template-list-hld">
              <v-row>
                <v-col md="4" sm="6" cols="12">
                  <div class="single-choice-template">
                    <img src="../../assets/Images/new-design-icons/image_2022_07_25T09_11_00_105Z.png"/>
                  </div>
                </v-col>
                <v-col md="4" sm="6" cols="12">
                  <div class="single-choice-template">
                    <img src="../../assets/Images/new-design-icons/image_2022_07_25T09_11_05_514Z.png"/>
                  </div>
                </v-col>
                <v-col md="4" sm="6" cols="12">
                  <div class="single-choice-template">
                    <img src="../../assets/Images/new-design-icons/image_2022_07_25T09_11_25_242Z.png"/>
                  </div>
                </v-col>
                <v-col md="4" sm="6" cols="12">
                  <div class="single-choice-template">
                    <img src="../../assets/Images/new-design-icons/image_2022_07_25T09_11_39_353Z.png"/>
                  </div>
                </v-col>
                <v-col md="4" sm="6" cols="12">
                  <div class="single-choice-template">
                    <img src="../../assets/Images/new-design-icons/image_2022_07_25T09_11_47_419Z.png"/>
                  </div>
                </v-col>
                <v-col md="4" sm="6" cols="12">
                  <div class="single-choice-template">
                    <img src="../../assets/Images/new-design-icons/image_2022_07_25T09_11_59_986Z.png"/>
                  </div>
                </v-col>
                <v-col md="4" sm="6" cols="12">
                  <div class="single-choice-template">
                    <img src="../../assets/Images/new-design-icons/image_2022_07_25T09_12_11_244Z.png"/>
                  </div>
                </v-col>
                <v-col md="4" sm="6" cols="12">
                  <div class="single-choice-template">
                    <img src="../../assets/Images/new-design-icons/image_2022_07_25T09_12_19_321Z.png"/>
                  </div>
                </v-col>
                <v-col md="4" sm="6" cols="12">
                  <div class="single-choice-template">
                    <img src="../../assets/Images/new-design-icons/image_2022_07_25T09_12_27_897Z.png"/>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-tab-item>
          <v-tab-item>
            <div class="template-list-hld">
              <v-row>
                <v-col md="4" sm="6" cols="12">
                  <div class="single-choice-template">
                    <img src="../../assets/Images/new-design-icons/image_2022_07_25T09_11_00_105Z.png"/>
                  </div>
                </v-col>
                <v-col md="4" sm="6" cols="12">
                  <div class="single-choice-template">
                    <img src="../../assets/Images/new-design-icons/image_2022_07_25T09_11_05_514Z.png"/>
                  </div>
                </v-col>
                <v-col md="4" sm="6" cols="12">
                  <div class="single-choice-template">
                    <img src="../../assets/Images/new-design-icons/image_2022_07_25T09_11_25_242Z.png"/>
                  </div>
                </v-col>
                <v-col md="4" sm="6" cols="12">
                  <div class="single-choice-template">
                    <img src="../../assets/Images/new-design-icons/image_2022_07_25T09_11_39_353Z.png"/>
                  </div>
                </v-col>
                
              </v-row>
            </div>
          </v-tab-item>
          <v-tab-item>
            <div class="template-list-hld">
              <v-row>
                <v-col md="4" sm="6" cols="12">
                  <div class="single-choice-template">
                    <img src="../../assets/Images/new-design-icons/image_2022_07_25T09_11_00_105Z.png"/>
                  </div>
                </v-col>
                <v-col md="4" sm="6" cols="12">
                  <div class="single-choice-template">
                    <img src="../../assets/Images/new-design-icons/image_2022_07_25T09_11_05_514Z.png"/>
                  </div>
                </v-col>
                <v-col md="4" sm="6" cols="12">
                  <div class="single-choice-template">
                    <img src="../../assets/Images/new-design-icons/image_2022_07_25T09_11_25_242Z.png"/>
                  </div>
                </v-col>
                <v-col md="4" sm="6" cols="12">
                  <div class="single-choice-template">
                    <img src="../../assets/Images/new-design-icons/image_2022_07_25T09_11_39_353Z.png"/>
                  </div>
                </v-col>
                
              </v-row>
            </div>
          </v-tab-item>
        </v-tabs-items>

        
      </v-card>
    </v-dialog>
    <RequestMeeting
      :key="requestMeetingKey"
      :attendee="currentAttendee"
    ></RequestMeeting>
  </div>
</template>

<style scoped>
@import "../../assets/expo.css";
@import "../../assets/Hotspot/css/jquery-hotspotter.min.css";
@import "../../assets/Hotspot/css/jquery-ui-1.9.2.custom.min.css";
</style>
<style>
.expo-listing-type-dropdown .v-input__slot {
  border: 1px solid #cbcbcb;
  box-shadow: none !important;
  height: 44px !important;
  margin-bottom: 0px !important;
}
.expo-listing-type-dropdown .v-text-field__details {
  display: none !important;
}
.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-left-enter {
  transform: translateX(100%);
}

.slide-left-leave-to {
  transform: translateX(-100%);
}

.slide-right-enter {
  transform: translateX(100%);
}

.slide-right-leave-to {
  transform: translateX(-100%);
}

.expo-wrapper-sec .meeting-request {
  color: #6cd2e7;
  background-color: #19a883;
  background-size: 20px;
  border-color: #6cd2e7;
  height: 52px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  border: 2px solid #fff;
  color: #fff;
  margin: 0;
  font-weight: 400;
  font-size: 1rem;
  padding-left: 52px;
  cursor: pointer;
  position: relative;
  z-index: 1;
}
.book-appointment-wrapper .meeting-request {
  border-radius: 6px 0 0 6px !important;
}
.expo-wrapper-sec .meeting-request:before {
  background: url(../../assets/Images/icons/calendar-check.svg) no-repeat 3px 2px;
  content: "";
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-repeat: no-repeat;
  width: 45px;
  height: 35px;
  right: auto;
  left: 10px;
}
.client-dialog-exhibitors {
  width: 1000px;
  /*min-height: 600px;
  max-height: 600px;*/
}
.client-dialog-exhibitors .v-sheet.v-card {
  border-radius: 0px !important;
}
.ex-dialog-body {
  /*margin: 20px !important;*/
  height: 530px;
}
.client-dialog-exhibitors .v-tab {
  text-transform: unset !important;
}
.client-dialog-exhibitors .tab-content {
  margin-top: 0px;
}
.client-dialog-exhibitors .tab-content .v-tab {
  margin-bottom: 10px;
}
.client-dialog-exhibitors .v-tab:first-child {
  margin-left: 0px !important;
}
.client-dialog-exhibitors .v-tab {
  padding: 6px !important;
}
.client-dialog-exhibitors .v-tabs.v-tabs--vertical .v-tab {
  padding: 0px !important;
  padding-right: 6px !important;
}
.client-dialog-exhibitors .v-tabs-bar {
  height: 60px !important;
}
.client-dialog-exhibitors .v-tabs.v-tabs--vertical .v-tabs-bar {
  height: unset !important;
}
#ClientLobbyCard a.v-tab {
  color: rgba(0, 0, 0, 0.54);
  font-size: 15px;
}
a.v-tab.v-tab--active {
  color: #1976d2 !important;
  border-bottom-color: #000;
}
.tab-top {
  font-size: 22px !important;
}
.tab-top.first-tab {
  margin-left: 32px !important;
}
.new-tool-tiphead .v-btn.tool-tip-loader {
  height: 32px;
}
@media only screen and (max-width: 767px) {
  .tab-top {
    font-size: 16px !important;
  }
  .tab-top.first-tab {
    margin-left: 5px !important;
  }
  .client-dialog-exhibitors .v-tabs-bar {
    height: 80px !important;
  }
  .client-dialog-exhibitors .v-tabs-bar a.tab-top {
    width: 45%;
  }
}
</style>

<style lang="scss">
.substitute-page-wrap {
  button.meeting-request {
    position: fixed !important;
    bottom: 15px;
    left: 50%;
    transform: translateX(-50%);

    color: #6cd2e7;
    background-color: #19a883;
    background-size: 20px;
    border-color: #6cd2e7;
    height: 52px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    border: 2px solid #fff;
    color: #fff;
    margin: 0;
    font-weight: 400;
    font-size: 1rem;
    padding-left: 52px;
    cursor: pointer;
    position: relative;
    z-index: 1;
    min-width: 210px;
  }
  //.meeting-request {
  //  border-radius: 6px 0 0 6px !important;
  //}
  button.meeting-request:before {
    background: url(../../assets/Images/icons/calendar-check.svg) no-repeat 3px 2px;
    content: "";
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background-repeat: no-repeat;
    width: 45px;
    height: 35px;
    right: auto;
    left: 10px;
  }

  .hall-top-area {
    padding: 15px 0;
  }
  .hall-top-area-inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .search-hall {
    border: 1px solid #dfdfdf;
    position: relative;
    border-radius: 4px 0 0 4px;
  }
  .search-hall input[type="text"] {
    border: none;
    height: 42px;
    width: 400px;
    background: transparent;
    padding: 0 15px 0 15px;
    font-size: 16px;
    font-weight: 400;
    color: #333333;
  }
  .search-hall img {
    position: absolute;
    left: 13px;
    top: 50%;
    transform: translateY(-50%);
  }
  .hall-booth-inner-wrap {
    background: #eee;
  }
  .hall-booth-inner-wrap {
    padding: 20px 0;
    margin-top: 30px;
  }
  .hall-booth-inner-wrap .single-booth {
    padding: 15px;
    background: #fff;
    border-radius: 10px;
    display: inline-flex;
    justify-content: flex-start;
    align-items: center;
    height: 100% !important;
    width: 100% !important;
    position: relative;
  }
  .hall-booth-inner-wrap .booth-image {
    height: 75px;
    background: #fff;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    flex: 150px 0 0;
    border: 1px solid #e6e8ea;
  }
  .hall-booth-inner-wrap .booth-image img {
    width: auto;
  }
  .hall-booth-inner-wrap .booth-description {
    padding-left: 18px;
  }
  .hall-booth-inner-wrap .booth-description p {
    color: #000;
    font-size: 18px;
    font-weight: 400;
    margin: 0;
  }
  .hall-booth-inner-wrap .booth-description .bookmark-icon {
    position: absolute;
    top: 7px;
    right: 7px;
  }
  .exhibitors-hall-grid-view-lite .booth-description .bookmark-icon {
    position: absolute;
    top: auto;
    bottom: 7px;
    right: 7px;
  }
  .exhibitors-hall-grid-view-lite .single-booth {
    flex-direction: column;
    width: 100%;
  }
  .exhibitors-hall-grid-view-lite .single-booth .booth-image {
    height: 250px;
    width: 100%;
    overflow: hidden;
    margin-bottom: 15px;
  }
  .hall-view-btn {
    margin-left: 15px;
  }
  .hall-view-btn img {
    position: relative !important;
    left: 0;
    top: 0;
  }
  .hall-top-right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .list-dark {
    display: none;
  }
  .single-hall-booth-wrap {
    padding: 7px 12px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .substitute-page-wrap {
    .hall-top-area-inner {
      align-items: flex-start;
      flex-direction: column;
    }
    .hall-booth-inner-wrap {
      min-height: 100vh;
      max-height: max-content;
    }
    .search-hall {
      width: 100%;
    }
    .search-hall input[type="text"] {
      width: 100%;
    }
    .hall-top-area-inner h3 {
      font-size: 22px;
    }
    .booth-image {
      height: 130px;
      width: 140px;
    }
    .exhibitors-hall-grid-view-lite .single-booth .booth-image {
      height: 95px;
    }
    .hall-top-right {
      width: 100%;
    }
    .hall-top-right .right-search-hld {
      width: 100%;
    }
  }
}
@media only screen and (max-width: 767px) {
  .substitute-page-wrap {
    .hall-top-area-inner {
      align-items: flex-start;
      flex-direction: column;
    }
    .search-hall {
      width: 100%;
    }
    .search-hall input[type="text"] {
      width: 100%;
    }
    .hall-top-area-inner h3 {
      font-size: 22px;
    }
    .booth-image {
      height: 130px;
      width: 140px;
    }
    .exhibitors-hall-grid-view-lite .single-booth .booth-image {
      height: 95px;
    }
    .hall-top-right {
      width: 100%;
    }
    .hall-top-right .right-search-hld {
      width: 100%;
    }
  }
}
</style>
<script>
import Vue from "vue";
import router from "../../router";
import store from "../../store";
import db from "../../components/firebaseInit";
import jQuery from "jquery";
import analytics from "@/components/Analytics";
let $ = jQuery;
import APIs from "@/components/APIInit";
import Exhibitors from "@/components/Exhibitors.vue";
import ExhibitorsMeeting from "@/components/ExhibitorsMeeting.vue";
import RequestMeeting from "@/components/RequestMeeting.vue";
import common from "@/common";
import { bus } from "@/main";

// let lastVisible = null;
// let hasMore = true;
var self;
import axios from "axios";
var interval = null;
export default {
  components: {
    Exhibitors,
    ExhibitorsMeeting,
    RequestMeeting,
  },
  data() {
    return {
      tab2: null,
      templateList: false,
      typeId: "",
      typeName: "",
      exhibitorType: "All",
      types: [{ TypeId: 0, TypeName: "All", BackgroundImg: null }],
      APIs: APIs,
      currentExpo: null,
      isBookmarked: false,
      isBookmarkLoading: false,
      headerText: this.$t("expo.exhibitors"),
      id: null,
      Name: null,
      BoothNo: null,
      Category: null,
      Email: null,
      Website: null,
      Image: null,
      Profile: null,
      Phone: null,
      HotspotImageUrL: null,
      MappedContacts: [],
      BroadcastData: [],
      exid: null,
      pageSize: 9,
      pageIndex: 0,
      totalRecords: 1,
      searchtext: "",
      filtertext: "",
      IsShowNoDataFound: false,
      IsShowCancelButton: false,
      IsSearchMode: false,
      lastVisible: null,
      ExhibitorData: [],
      DropFilter: [],
      Exhibitorlist: [],
      ExhibitorSettings: [],
      totalCount: 0,
      stRange: 0,
      endRange: 7,
      textColor: "black",
      clientID: this.$store.getters.getClient[0].id,
      eventId: "",
      uid: "",
      visitor: true,
      sortedSocialLinks: [],
      ExpoHallDefaultBackgroundImage: "",
      ExpoHallBackgroundImage: "",
      searchType: 0,
      showTooltips: false,
      orderBy: "BoothNo", //("Name","BoothNo")
      show: true,
      transitionType: "",
      dialog: false,
      tab: "schedule",
      allowRequestMeetingInExpoHall: false,
      requestMeetingKey: 0,
      currentAttendee: null,
      allowRequestMeeting: true,
      exCount: 0,
      mobileView: false,
      screenWidth: 0,
    };
  },
  computed: {
    getAdvExpoflag() {
      if (self.visitor) {
        return true;
      } else {
        var obj = JSON.parse(window.localStorage.getItem("my-app"));
        return obj.advExpo;
      }
    },
    getFilteredExhibitorList() {
      self.stRange = 0;
      self.endRange = 7;
      if (self.exhibitorType == "All") {
        self.exCount = self.Exhibitorlist.length;
        return self.Exhibitorlist;
      } else {
        var result = [];
        result = self.Exhibitorlist.filter(function (item) {
          let filtered = false;
          if (self.exhibitorType && self.exhibitorType.length > 0) {
            if (item.Type) {
              filtered = item.Type.TypeName == self.exhibitorType.trim();
            }
          }
          return filtered;
        });
        self.exCount = result.length;
        return result;
      }
    },
  },
  watch: {
    screenWidth(val) {
      if (val > 768) {
        self.mobileView = false;
      } else {
        self.mobileView = true;
      }
    },
  },
  created() {
    self = this;
    self.screenWidth = window.innerWidth;
    window.addEventListener("resize", () => {
      self.screenWidth = window.innerWidth;
    });
    self.uid = self.getSessionUserId();
    self.visitor = self.isVisitor();
    self.event_collectionName = self.getEventCollectionName();
    db.collection(self.event_collectionName)
      .doc("AttendeeList")
      .collection("Attendees")
      .doc(self.uid)
      .get()
      .then((attendeeDoc) => {
        if (attendeeDoc.exists) {
          var attendee = attendeeDoc.data();
          var registrationType = "";
          if (typeof attendee.RegistrationType == "string") {
            registrationType = attendee.RegistrationType;
          } else if (typeof attendee.RegistrationType == "object") {
            registrationType = attendee.RegistrationType.RegistrationType;
          }
          db.collection(self.event_collectionName)
            .doc("AttendeeList")
            .collection("AttendeeSettings")
            .doc("FilterSettings")
            .get()
            .then((doc) => {
              if (doc.exists) {
                var data = doc.data();
                if (data.MeetingRestrictionEnabled) {
                  if (
                    data.AllowExMtngRqstForRegTypes &&
                    data.AllowExMtngRqstForRegTypes.length > 0 &&
                    !data.AllowExMtngRqstForRegTypes.includes(registrationType)
                  ) {
                    self.allowRequestMeeting = false;
                  }
                  if (
                    self.allowRequestMeeting &&
                    data.ExcludeGroupToRequestMeeting
                  ) {
                    self.restrictedAttendeeIDs = [];
                    debugger;
                    let headers = {
                      "content-type": "application/json",
                      Authorization: "Bearer " + self.getSessionToken(),
                    };
                    let requestData = {
                      key: {
                        instanceId: "OA_UAT",
                        clientId: self.$store.state.client[0].id,
                        eventId: self.$store.state.eventid,
                      },
                      data: {
                        groups: [
                          {
                            GroupId: data.ExcludeGroupToRequestMeeting,
                          },
                        ],
                      },
                    };
                    axios
                      .post(APIs.GetAttendees, requestData, {
                        headers: headers,
                      })
                      .then((responseData) => {
                        if (
                          responseData &&
                          responseData.data &&
                          responseData.data.status == 0 &&
                          responseData.data.groups
                        ) {
                          responseData.data.groups.forEach(function (group) {
                            if (group.attendees) {
                              group.attendees.forEach(function (item) {
                                if (item.AttendeeId == self.uid) {
                                  self.allowRequestMeeting = false;
                                }
                              });
                            }
                          });
                        } else {
                          console.log("Unable to fetch group attendees");
                        }
                      })
                      .catch((error) => {
                        //alert(error);
                        console.log(error);
                      });
                  }
                }
              }
            });
        }
      });
    if (self.mobileView) {
      self.hallGridView();
    }
  },
  beforeMount() {
    this.ExpoClick();
  },
  async mounted() {
     var data = {
      showUserWelcomeLoader: false,
    };

    bus.$emit("setUserWelcomeLoader", data);
    debugger;

    console.log("rt------", self.$route.query);
    if (self.$route.query.type) {
      self.typeId = self.$route.query.eid;
      self.typeName = self.$route.query.type;
    }

    console.log("tt1------", self.typeId);
    console.log("tt2------", self.typeName);

    self.getfilters();
    if (self.DropFilter.length > 1) {
      //$("#dvSelFilter").show();
      $("#dvFiltermain").removeClass("d-none");
    } else {
      //$("#dvSelFilter").hide();
      $("#dvFiltermain").addClass("d-none");
    }
    /*++++++++ Header color Brancing JSON ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
    var obj = JSON.parse(window.localStorage.getItem("my-app"));

    if (obj.expoToolTip == true) {
      self.showTooltips = true;
    } else {
      self.showTooltips = false;
    }

    //-------------------FAVICONJOB------------------------------------------------------------

    if (obj.branding[0].favicon != undefined) {
      if (obj.branding[0].favicon != "") {
        var link =
          document.querySelector("link[rel*='icon']") ||
          document.createElement("link");
        link.type = "image/x-icon";
        link.rel = "shortcut icon";
        link.href = obj.branding[0].favicon;
        document.getElementsByTagName("head")[0].appendChild(link);
      }
    }
    //----------------------------------------------------------------------------------
    var brandingData;
    try {
      brandingData = await self.getBrandingJSONDetails(
        obj.eventcollectionname + "/Branding/Branding.json"
      );
      if (brandingData.data != undefined) {
        // if (brandingData.data.EventInfo != undefined) {
        //   if (brandingData.data.EventInfo.BodyTextColor != undefined) {
        //     self.textColor = brandingData.data.EventInfo.BodyTextColor;
        //   } else {
        //     self.textColor = "black !important";
        //   }
        // } else {
        //   self.textColor = "black !important";
        // }

        $("#headerText").css("color", self.textColor);
      }
    } catch (e) {
      console.log("Error in Branding Json Fetch--", e);
    }
    //------------------------------------------------------------------------------
    if (this.DropFilter.length == 0) {
      this.getfilters();
    }

    $("#topmenu").show();
    $("#leftmenu").show();
    $("#btnAddUserView").click();
    self.searchtext = "";
    self.getSettings();
    debugger;
    setTimeout(() => {
      self.getExhibitors();
    }, 1000);
    interval = setInterval(() => {
      this.selectExpoMenu();
    }, 2000);
    //-------Page Title-------------
    self.headerText = "Exhibitors";
    db.collection(obj.eventcollectionname)
      .doc("Menu")
      .get()
      .then((doc) => {
        var data = doc.data();
        $.each(data.LeftMenu, function (key, value) {
          if (value.GroupID != 99) {
            if (value.Name == "Exhibitors") {
              if (self.$store.state.locale == "English") {
                self.headerText = value.DisplayLabel;
              } else if (self.$store.state.locale == "German") {
                self.headerText = value.DisplayLabel_de;
              } else if (self.$store.state.locale == "French") {
                self.headerText = value.DisplayLabel_fr;
              } else if (self.$store.state.locale == "Chinese") {
                self.headerText = value.DisplayLabel_zh;
              } else {
                self.headerText = value.DisplayLabel;
              }
            }
          }
        });
        $.each(data.AllMenu, function (key, value) {
          if (value.GroupID != 99) {
            if (value.Name == "Exhibitors") {
              if (self.$store.state.locale == "English") {
                self.headerText = value.DisplayLabel;
              } else if (self.$store.state.locale == "German") {
                self.headerText = value.DisplayLabel_de;
              } else if (self.$store.state.locale == "French") {
                self.headerText = value.DisplayLabel_fr;
              } else if (self.$store.state.locale == "Chinese") {
                self.headerText = value.DisplayLabel_zh;
              } else {
                self.headerText = value.DisplayLabel;
              }
            }
          }
        });
        document.title = self.headerText + " - " + obj.eventname;
      });

    //-------------dynamic font selection --------------------------------------
    if (obj.EventFont != undefined) {
      if (obj.EventFont.length > 0) {
        var urlpath = "";
        if (obj.EventFont[0].FontPath != "") {
          if (obj.EventFont[0].FontFamily != "") {
            urlpath = obj.EventFont[0].FontPath;

            var newStyle = document.createElement("style");
            newStyle.appendChild(
              document.createTextNode(
                "\
@font-face {\
    font-family: " +
                  obj.EventFont[0].FontFamily +
                  ";\
    src:" +
                  urlpath +
                  " ;\
}\
"
              )
            );

            document.head.appendChild(newStyle);

            $(
              "<style>* { font-family: '" +
                obj.EventFont[0].FontFamily +
                "' !important }</style>"
            ).appendTo("head");
          }
        } else {
          $("<style>* { font-family: 'Roboto' !important }</style>").appendTo(
            "head"
          );
        }
      }
    }
    //-------------dynamic font selection --------------------------------------
    this.getExhibitorTypes();
    window.addEventListener("keydown", this.onKeyboardArrowPress);
  },
  beforeDestroy() {
    this.lastVisible = null;
    self.Exhibitorlist = [];
    self.filterText = "";
    self.DropFilter = [];
    self.searchtext = "";
    clearInterval(interval);
    self.removeSelection();
  },
  destroyed() {
    window.removeEventListener("keydown", this.onKeyboardArrowPress);
  },
  methods: {
    templateListDialog(){
      self.templateList = true;
    },
    hallGridView() {
      $(".hall-booth-inner-wrap").addClass("exhibitors-hall-grid-view-lite");
      $(".grid-dark").css("display", "none");
      $(".list-dark").css("display", "block");
      $(".single-hall-booth-wrap").removeClass("col-12");
      // $(".single-hall-booth-wrap").addClass("col-6");
    },
    hallListView() {
      $(".hall-booth-inner-wrap").removeClass("exhibitors-hall-grid-view-lite");
      $(".list-dark").css("display", "none");
      $(".grid-dark").css("display", "block");
      $(".single-hall-booth-wrap").removeClass("col-6");
      $(".single-hall-booth-wrap").addClass("col-12");
    },
    updateBGImageByType(val) {
      if (val == "All") {
        self.exhibitorType= "All";
        self.ExpoHallBackgroundImage =  self.ExpoHallDefaultBackgroundImage;
        //self.getSettings();
      } else {
        self.types.map((type) => {
          if (type.TypeName.trim() == val.trim()) {
            self.ExpoHallBackgroundImage = type.BackgroundImg
              ? self.getCDNUrl(type.BackgroundImg)
              : self.ExpoHallDefaultBackgroundImage;
          }
        });
      }
    },
    getExhibitorTypes() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var docRef;

      docRef = db
        .collection(obj.eventcollectionname)
        .doc("ExhibitorTypeList")
        .collection("Types")
        .orderBy("TypeName", "asc");
      docRef
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.types.push({
              TypeId: doc.data().TypeId,
              TypeName: doc.data().TypeName,
              BackgroundImg: doc.data().BackgroundImg,
            });
          });
          if (self.typeId != "" && self.typeName != "") {
            this.types.map((type) => {
              if (type.TypeId == self.typeId) {
                self.exhibitorType = type.TypeName;
                self.updateBGImageByType(type.TypeName);
              }
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async addBookMark(entityId, entityName, entityImage) {
      if (self.visitor) {
        common.openRegistrationDialog();
        return;
      }
      if (!entityId) {
        entityName = this.currentExpo.Name;
        entityImage = this.currentExpo.Logo ? this.currentExpo.Logo : "";
        entityId = this.currentExpo.id;
      }
      var exhibitors = self.Exhibitorlist.filter(function (item) {
        return item.id == entityId;
      });
      if (exhibitors.length > 0) {
        exhibitors[0].isBookmarkLoading = true;
      } else {
        return;
      }
      let rqstData = {
        key: {
          instanceId: "OA_UAT",
          clientId: this.$store.state.client[0].id,
          eventId: this.$store.state.eventid,
        },
        data: {
          eventName: this.$store.state.eventname,
          enetityUserId: this.$store.state.userId,
          attendeeId: this.$store.state.userId,
          entityType: 4,
          entityName: entityName,
          entityImage: entityImage,
          entityId: entityId,
          entityLink: this.$route.path,
        },
      };
      if (exhibitors[0].isBookmarked) {
        axios({
          method: "post",
          url: self.APIs.BookmarkAPIConfig.Delete,
          data: rqstData,
        })
          .then(() => {
            exhibitors[0].isBookmarked = false;
            exhibitors[0].isBookmarkLoading = false;
          })
          .catch(() => {
            exhibitors[0].isBookmarkLoading = false;
          });
      } else {
        axios({
          method: "post",
          url: self.APIs.BookmarkAPIConfig.Create,
          data: rqstData,
        })
          .then(() => {
            exhibitors[0].isBookmarked = true;
            exhibitors[0].isBookmarkLoading = false;
          })
          .catch(() => {
            exhibitors[0].isBookmarkLoading = false;
          });
      }
    },
    onKeyboardArrowPress(event) {
      //event.preventDefault();
      const key = event.key;
      switch (key) {
        case "ArrowLeft":
          // Left pressed
          if (this.stRange != 0) {
            this.getPrvLot();
          }
          break;
        case "ArrowRight":
          if (this.endRange != this.totalCount) {
            this.getNextLot();
          }
          break;
      }
    },
    loopArray: function (arr) {
      var obj = [];
      var i;

      for (i = 0; i < arr.length; i++) {
        let socialkeys = Object.keys(arr[i]);
        let socialvaues = Object.values(arr[i]);
        if (socialvaues[0] !== "") {
          if (socialvaues[0].indexOf("http") < 0) {
            socialvaues[0] = "http://" + socialvaues[0];
          }
        }
        obj.push({ key: socialkeys[0], value: socialvaues[0] });
      }
      this.sortedSocialLinks = obj;
      this.sortedSocialLinks.sort(function (x, y) {
        let a = x.key.toUpperCase(),
          b = y.key.toUpperCase();
        return a == b ? 0 : a > b ? 1 : -1;
      });
    },
    showtooltip: async function (id, currentExpo) {
      if (!self.mobileView) {
        $(".custom-tool-tip-left").hide();
        $(".custom-tool-tip-right").hide();
        $("#infotoolTip" + id).show();
        //$('.custom-tool-tip-left').show();
      }
      var exhibitors = self.Exhibitorlist.filter(function (item) {
        return item.id == id;
      });
      if (exhibitors.length > 0) {
        if (exhibitors[0].isBookmarked == undefined) {
          exhibitors[0].isBookmarkLoading = true;
        } else {
          return;
        }
      }
      this.currentExpo = currentExpo;
      let rqstData = {
        key: {
          instanceId: "OA_UAT",
          clientId: this.$store.state.client[0].id,
          eventId: this.$store.state.eventid,
        },
        data: {
          eventName: this.$store.state.eventname,
          enetityUserId: this.$store.state.userId,
          attendeeId: this.$store.state.userId,
          entityType: 4,
          entityName: this.currentExpo.Name,
          entityImage: this.currentExpo.Image ? this.currentExpo.Image : "",
          entityId: id,
        },
      };
      try {
        let bookmarkExists = await axios({
          method: "post",
          url: this.APIs.BookmarkAPIConfig.Get,
          data: rqstData,
        });
        if (bookmarkExists.data && bookmarkExists.data.isPublished) {
          exhibitors[0].isBookmarked = true;
        } else {
          exhibitors[0].isBookmarked = false;
        }
        exhibitors[0].isBookmarkLoading = false;
        //self.Exhibitorlist = self.Exhibitorlist.filter(function () {
        //  return true;
        //});
      } catch (e) {
        console.log(e);
        exhibitors[0].isBookmarkLoading = false;
        //self.Exhibitorlist = self.Exhibitorlist.filter(function () {
        //  return true;
        //});
      }
    },

    openBooth(data) {
      store.commit("addExhibitorID", data.id);
      var url = "exhibitorsview/" + data.id + "/" + data.Name;
      router.push(url.replace(/ /g, "_"));
    },
    closetooltip: function (val) {
      $("#infotoolTip" + val).hide();
      $(".custom-tool-tip-left").hide();
      $(".custom-tool-tip-right").hide();
    },
    getfilters() {
      self.DropFilter = [];
      // this.DropFilter.push({ id: "All", value: "All" });
      // this.DropFilter.push({ id: "General", value: "General" });
      // this.DropFilter.push({ id: "Platinum", value: "Platinum" });
      // this.DropFilter.push({ id: "Gold", value: "Gold" });
      // this.DropFilter.push({ id: "Silver", value: "Silver" });
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      self.DropFilter.push({ id: "All", value: "All" });
      var docref = db
        .collection(obj.eventcollectionname)
        .doc("ExhibitorCategories")
        .collection("Category");

      docref
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            self.DropFilter.push({ id: doc.id, value: doc.id });
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    showLoader: function () {
      if ($("#divLoading") != null) {
        $("#divLoading").show();
      }
    },

    hideLoader: function () {
      //if (timerLoader != null) {
      clearTimeout(this.timerLoader);
      // console.log("outside");
      if ($("#divLoading") != null) {
        //console.log("inside");
        $("#divLoading").hide();
      }
      //}
    },
    getEventID() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      return obj.eventid;
    },
    AddAnalitics: function (btnName, action) {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj !== undefined) {
        var eventName;
        if (obj.eventname !== undefined) {
          eventName = obj.eventname;
        } else {
          eventName = "";
        }
        var actionType = "";
        var actionLabel = "";
        if (action !== "scroll") {
          actionType = btnName.target.tagName.toLowerCase();
          if (btnName.target.getAttribute("data-tag") !== undefined) {
            if (btnName.target.getAttribute("data-tag") === null) {
              return false;
            }
            actionLabel = btnName.target.getAttribute("data-tag");

            if (actionLabel !== "") {
              this.event_collectionName = obj.eventcollectionname;
              analytics.AddUserAction(
                this.event_collectionName,
                eventName,
                location.pathname,
                action,
                actionType,
                actionLabel,
                obj.user[0].id,
                obj.user[0].fname + " " + obj.user[0].lname,
                obj.user[0].Email
              );
            }
          }
        } else {
          this.event_collectionName = obj.eventcollectionname;
          analytics.AddUserAction(
            this.event_collectionName,
            eventName,
            location.pathname,
            action,
            actionType,
            actionLabel,
            obj.user[0].id,
            obj.user[0].fname + " " + obj.user[0].lname,
            obj.user[0].Email
          );
        }
      }
    },
    onClickHandler(event) {
      // event.target is the clicked element object
      this.AddAnalitics(event, "click");
    },
    getExhibitors: function () {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      // console.log("EventColName : " + obj.eventcollectionname);
      this.Exhibitorlist = [];
      var docRef;

      self.filterText = $("#selFilter option:selected").text();
      //console.log(filterText);
      if (self.filterText.trim() != "All") {
        if (self.filterText != "") {
          docRef = db
            .collection(obj.eventcollectionname)
            .doc("ExhibitorList")
            .collection("Exhibitors")
            .orderBy(self.orderBy, "asc")
            .where("Category", "==", self.filterText)
            .where("IsPublished", "==", true);
        } else {
          docRef = db
            .collection(obj.eventcollectionname)
            .doc("ExhibitorList")
            .collection("Exhibitors")
            .orderBy(self.orderBy, "asc")
            .where("IsPublished", "==", true);
        }
      } else {
        docRef = db
          .collection(obj.eventcollectionname)
          .doc("ExhibitorList")
          .collection("Exhibitors")
          .orderBy(self.orderBy, "asc")
          .where("IsPublished", "==", true);
      }

      if (self.searchtext.trim() != "") {
        if (self.searchType == 0) {
          $("#divExhibitor").html("");
          self.hideLoader();
          self.Exhibitorlist = [];

          docRef
            .get()
            .then((querySnapshot) => {
              var ctr = 0;
              var id = "";
              self.Exhibitorlist = [];
              querySnapshot.forEach((doc) => {
                id += doc.id + ",";
                var exhibitors = self.Exhibitorlist.filter(function (item) {
                  return item.id == id;
                });
                if (exhibitors.length == 0) {
                  var webSite = "";
                  if (doc.data().Website !== "") {
                    if (doc.data().Website.indexOf("http") < 0) {
                      webSite = "http://" + doc.data().Website;
                    } else {
                      webSite = doc.data().Website;
                    }
                  }
                  var socLinks = doc.data().SocialLinks;
                  self.loopArray(socLinks);
                  socLinks = self.sortedSocialLinks;

                  var tbObj = new Object();
                  (tbObj.sino = ctr++),
                    (tbObj.id = doc.id),
                    (tbObj.Name =
                      doc.data().Name != undefined ? doc.data().Name : ""),
                    (tbObj.Logo =
                      doc.data().Logo != undefined ? doc.data().Logo : ""),
                    (tbObj.Email =
                      doc.data().Email != undefined ? doc.data().Email : ""),
                    (tbObj.Category =
                      doc.data().Category != undefined
                        ? doc.data().Category
                        : ""),
                    (tbObj.Type =
                      doc.data().Type != undefined ? doc.data().Type : ""),
                    (tbObj.BoothNo =
                      doc.data().BoothNo != undefined
                        ? doc.data().BoothNo
                        : ""),
                    (tbObj.HotspotImageUrL =
                      doc.data().HotspotImageURL != undefined
                        ? self.getCDNUrl(doc.data().HotspotImageURL)
                        : ""),
                    (tbObj.Website = webSite != undefined ? webSite : ""),
                    (tbObj.Profile =
                      (doc.data().Profile != undefined
                        ? doc.data().Profile
                        : ""
                      )
                        .replace(/<[^>]*>/g, "\n\r")
                        .substring(0, 300) + "..."),
                    (tbObj.isTooltipVisible = false),
                    (tbObj.FullProfile =
                      doc
                        .data()
                        .Profile.replace(/<[^>]*>/g, "\n\r")
                        .substring(0, 500) + "..."),
                    (tbObj.Phone =
                      doc.data().Phone != undefined ? doc.data().Phone : ""),
                    (tbObj.Image =
                      doc.data().Logo != undefined
                        ? self.getCDNUrl(doc.data().Logo)
                        : ""),
                    (tbObj.SocialLinks =
                      doc.data().SocialLinks != undefined ? socLinks : []),
                    (tbObj.MappedContacts = doc.data().MappedContacts =
                      undefined ? doc.data().MappedContacts : []),
                    (tbObj.contactcount =
                      doc.data().MappedContacts.length != undefined
                        ? doc.data().MappedContacts.length
                        : 0),
                    (tbObj.Files =
                      doc.data().Resources != undefined
                        ? doc.data().Resources
                        : []),
                    (tbObj.fileLength =
                      doc.data().Resources.length != undefined
                        ? doc.data().Resources.length
                        : 0),
                    (tbObj.ShowcaseVideoURL =
                      doc.data().ShowcaseVideoURL != undefined
                        ? doc.data().ShowcaseVideoURL
                        : "");

                  if (
                    tbObj.Name.toLowerCase().includes(
                      self.searchtext.toLowerCase()
                    ) ||
                    tbObj.Email.toLowerCase().includes(
                      self.searchtext.toLowerCase()
                    ) ||
                    tbObj.Category.toLowerCase().includes(
                      self.searchtext.toLowerCase()
                    ) ||
                    tbObj.Website.toLowerCase().includes(
                      self.searchtext.toLowerCase()
                    ) ||
                    tbObj.Profile.toLowerCase().includes(
                      self.searchtext.toLowerCase()
                    )
                  ) {
                    tbObj.isBookmarkLoading = false;
                    self.Exhibitorlist.push(tbObj);

                    // console.log("count " + self.Exhibitorlist.length);
                    this.totalCount = self.Exhibitorlist.length;

                    this.stRange = 0;
                    if (self.Exhibitorlist.length < 7) {
                      this.endRange = self.Exhibitorlist.length;
                    } else {
                      this.endRange = 7;
                    }
                    if (self.orderBy == "BoothNo") {
                      self.Exhibitorlist.sort(function (a, b) {
                        let aName = parseInt(a.BoothNo);
                        let bName = parseInt(b.BoothNo);
                        if (aName < bName) {
                          return -1;
                        }
                        if (aName > bName) {
                          return 1;
                        }
                        return 0;
                      });
                    } else {
                      self.Exhibitorlist.sort(function (a, b) {
                        let aName = a.Name.trim().toLowerCase();
                        let bName = b.Name.trim().toLowerCase();
                        if (aName < bName) {
                          return -1;
                        }
                        if (aName > bName) {
                          return 1;
                        }
                        return 0;
                      });
                    }

                    store.commit("addExbList", id.substring(0, id.length - 1));
                  }
                  var exhibitorIds1 = "";
                  self.Exhibitorlist.map((item) => {
                    exhibitorIds1 += item.id + ",";
                  });

                  if (exhibitorIds1 != "") {
                    exhibitorIds1 = exhibitorIds1.substring(
                      0,
                      exhibitorIds1.length - 1
                    );
                  }
                  store.commit("addExbList", exhibitorIds1);
                }
              });
              self.Exhibitorlist.map(function (item) {
                self.showtooltip(item.id, item);
              });
              if (self.Exhibitorlist.length > 0) {
                self.IsShowNoDataFound = false;
              } else {
                self.IsShowNoDataFound = true;
              }
            })
            .catch((error) => {
              console.log(error);
              self.hideLoader();

              self.IsShowNoDataFound = true;
              return false;
            });
        } else {
          self.IsSearchMode = true;
          $("#divExhibitor").html("");

          //----------------------------------------------------------------------------------------
          var hostUrl = location.host.toLowerCase();
          var searchUrl = "";
          if (hostUrl.includes("localhost")) {
            searchUrl =
              "https://us-central1-uate2monair.cloudfunctions.net/app/api/searchexhibitors/" +
              this.searchtext;
          } else {
            if (hostUrl.includes("uat")) {
              searchUrl =
                "https://us-central1-uate2monair.cloudfunctions.net/app/api/searchexhibitors/" +
                this.searchtext;
            } else {
              searchUrl =
                "https://us-central1-e2monair.cloudfunctions.net/app/api/searchexhibitors/" +
                this.searchtext;
            }
          }
          //----------------------------------------------------------------------------------------------------

          console.log(this.clientID);
          this.eventId = this.getEventID();
          console.log(this.eventId);

          //+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
          self.showLoader();
          let headers = {
            "Content-Type": "application/json",
            apikey: "ws2000rb28082019",
            InstancePrefix: "OA",
            clientID: this.clientID, // "C1591205467009",
            Env: "UAT",
            eventID: this.eventId, //"E1591206650065",
          };
          axios
            .get(searchUrl, false, {
              headers: headers,
            })
            .then((data) => {
              self.hideLoader();
              console.log(data);
              var ctr = 0;
              var id = "";
              self.Exhibitorlist = [];
              for (var i = 0; i < data.length; i++) {
                var exhibitors = self.Exhibitorlist.filter(function (item) {
                  return item.id == data[i].ExhibitorId;
                });
                if (exhibitors.length > 0) {
                  continue;
                }
                if (data[i].IsPublished === true) {
                  id += data[i].ExhibitorId + ",";
                  var webSite = "";
                  if (data[i].Website !== "") {
                    if (data[i].Website.indexOf("http") < 0) {
                      webSite = "http://" + data[i].Website;
                    } else {
                      webSite = data[i].Website;
                    }
                  }
                  var socLinks = data[i].SocialLinks;
                  self.loopArray(socLinks);
                  socLinks = self.sortedSocialLinks;

                  var tbObj = new Object();

                  (tbObj.sino = ctr++),
                    (tbObj.id = data[i].ExhibitorId),
                    (tbObj.Name =
                      data[i].Name != undefined ? data[i].Name : ""),
                    (tbObj.Logo =
                      data[i].Logo != undefined
                        ? self.getCDNUrl(data[i].Logo)
                        : ""),
                    (tbObj.Email =
                      data[i].Email != undefined ? data[i].Email : ""),
                    (tbObj.Category =
                      data[i].Category != undefined ? data[i].Category : ""),
                    (tbObj.Type =
                      data[i].Type != undefined ? data[i].Type : ""),
                    (tbObj.BoothNo =
                      data[i].BoothNo != undefined ? data[i].BoothNo : ""),
                    (tbObj.HotspotImageUrL =
                      data[i].HotspotImageURL != undefined
                        ? self.getCDNUrl(data[i].HotspotImageURL)
                        : ""),
                    (tbObj.Website = webSite != undefined ? webSite : ""),
                    (tbObj.isTooltipVisible = false),
                    (tbObj.FullProfile =
                      (data[i].Profile != undefined ? data[i].Profile : "")
                        .replace(/<[^>]*>/g, "\n\r")
                        .substring(0, 500) + "..."),
                    (tbObj.Profile =
                      (data[i].Profile != undefined ? data[i].Profile : "")
                        .replace(/<[^>]*>/g, "\n\r")
                        .substring(0, 300) + "..."),
                    (tbObj.Phone =
                      data[i].Phone != undefined ? data[i].Phone : ""),
                    (tbObj.Image =
                      data[i].Logo != undefined
                        ? self.getCDNUrl(data[i].Logo)
                        : ""),
                    (tbObj.SocialLinks =
                      data[i].SocialLinks != undefined ? socLinks : []),
                    (tbObj.MappedContacts =
                      data[i].MappedContacts != undefined
                        ? data[i].MappedContacts
                        : []),
                    (tbObj.contactcount =
                      data[i].MappedContacts != undefined
                        ? data[i].MappedContacts.length
                        : 0),
                    (tbObj.Files =
                      data[i].Resources != undefined ? data[i].Resources : []),
                    (tbObj.fileLength =
                      data[i].Resources != undefined
                        ? data[i].Resources.length
                        : 0),
                    (tbObj.ShowcaseVideoURL =
                      data[i].ShowcaseVideoURL != undefined
                        ? data[i].ShowcaseVideoURL
                        : "");

                  tbObj.isBookmarkLoading = false;
                  self.Exhibitorlist.push(tbObj);
                  this.totalCount = self.Exhibitorlist.length;

                  this.stRange = 0;
                  if (self.Exhibitorlist.length < 7) {
                    this.endRange = self.Exhibitorlist.length;
                  } else {
                    this.endRange = 7;
                  }
                  if (self.orderBy == "BoothNo") {
                    self.Exhibitorlist.sort(function (a, b) {
                      let aName = parseInt(a.BoothNo);
                      let bName = parseInt(b.BoothNo);
                      if (aName < bName) {
                        return -1;
                      }
                      if (aName > bName) {
                        return 1;
                      }
                      return 0;
                    });
                  } else {
                    self.Exhibitorlist.sort(function (a, b) {
                      let aName = a.Name.trim().toLowerCase();
                      let bName = b.Name.trim().toLowerCase();
                      if (aName < bName) {
                        return -1;
                      }
                      if (aName > bName) {
                        return 1;
                      }
                      return 0;
                    });
                  }
                  store.commit("addExbList", id.substring(0, id.length - 1));
                  var exhibitorIds3 = "";
                  self.Exhibitorlist.map((item) => {
                    exhibitorIds3 += item.id + ",";
                  });

                  if (exhibitorIds3 != "") {
                    exhibitorIds3 = exhibitorIds3.substring(
                      0,
                      exhibitorIds3.length - 1
                    );
                  }
                  store.commit("addExbList", exhibitorIds3);
                }
              }
              self.Exhibitorlist.map(function (item) {
                self.showtooltip(item.id, item);
              });

              if (self.Exhibitorlist.length > 0) {
                self.IsShowNoDataFound = false;
              } else {
                self.IsShowNoDataFound = true;
              }
            })
            .catch((error) => {
              console.log("error---", error);
              self.hideLoader();

              self.IsShowNoDataFound = true;
              return false;
            });

          //++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
        }
      } else {
        docRef
          .get()
          .then((querySnapshot) => {
            var ctr = 0;
            var id = "";
            // if (this.DropFilter.length == 0) {
            //   this.getfilters();
            // }
            self.Exhibitorlist = [];
            querySnapshot.forEach((doc) => {
              if (this.searchtext !== "") {
                if (querySnapshot.docs.length == 1) {
                  this.loadView(doc.id, doc.Name);
                }
              } else {
                id += doc.id + ",";
                var exhibitors = self.Exhibitorlist.filter(function (item) {
                  return item.id == id;
                });
                if (exhibitors.length == 0) {
                  //console.log(doc.data().HotspotImageURL);
                  var webSite = "";
                  if (doc.data().Website !== "") {
                    if (doc.data().Website.indexOf("http") < 0) {
                      webSite = "http://" + doc.data().Website;
                    } else {
                      webSite = doc.data().Website;
                    }
                  }
                  var socLinks = doc.data().SocialLinks;
                  self.loopArray(socLinks);
                  socLinks = self.sortedSocialLinks;

                  // if (
                  //   doc.data().SocialLinks[0].Facebook !== "" &&
                  //   doc.data().SocialLinks[0].Facebook !== undefined
                  // ) {
                  //   if (doc.data().SocialLinks[0].Facebook.indexOf("http") < 0) {
                  //     socLinks[0].Facebook =
                  //       "http://" + doc.data().SocialLinks[0].Facebook;
                  //   }
                  // }
                  // if (
                  //   doc.data().SocialLinks[1].Twitter !== "" &&
                  //   doc.data().SocialLinks[1].Twitter !== undefined
                  // ) {
                  //   if (doc.data().SocialLinks[1].Twitter.indexOf("http") < 0) {
                  //     socLinks[1].Twitter =
                  //       "http://" + doc.data().SocialLinks[1].Twitter;
                  //   }
                  // }
                  // if (
                  //   doc.data().SocialLinks[2].LinkedIn !== "" &&
                  //   doc.data().SocialLinks[2].Twitter !== undefined
                  // ) {
                  //   if (doc.data().SocialLinks[2].LinkedIn.indexOf("http") < 0) {
                  //     socLinks[2].LinkedIn =
                  //       "http://" + doc.data().SocialLinks[2].LinkedIn;
                  //   }
                  // }

                  this.Exhibitorlist.push({
                    sino: ctr++,
                    id: doc.id,
                    Name: doc.data().Name,
                    Logo: self.getCDNUrl(doc.data().Logo),
                    Email: doc.data().Email,
                    Category: doc.data().Category,
                    Type: doc.data().Type,
                    BoothNo: doc.data().BoothNo,
                    HotspotImageUrL: self.getCDNUrl(doc.data().HotspotImageURL),
                    Website: webSite,
                    Profile:
                      doc
                        .data()
                        .Profile.replace(/<[^>]*>/g, "\n\r")
                        .substring(0, 300) + "...",
                    Phone: doc.data().Phone,
                    Image: self.getCDNUrl(doc.data().Logo),
                    SocialLinks: socLinks,
                    MappedContacts: doc.data().MappedContacts,
                    contactcount: doc.data().MappedContacts.length,
                    Files: doc.data().Resources,
                    fileLength: doc.data().Resources.length,
                    ShowcaseVideoURL: doc.data().ShowcaseVideoURL,
                    isTooltipVisible: false,
                    FullProfile:
                      doc
                        .data()
                        .Profile.replace(/<[^>]*>/g, "\n\r")
                        .substring(0, 500) + "...",
                    isBookmarkLoading: false,
                  });
                }
              }

              // this.DropFilter.push({
              //   id: doc.data().Category,
              //   value: doc.data().Category,
              // });
              self.Exhibitorlist.map(function (item) {
                self.showtooltip(item.id, item);
              });
            });
            if (self.orderBy == "BoothNo") {
              self.Exhibitorlist.sort(function (a, b) {
                let aName = parseInt(a.BoothNo);
                let bName = parseInt(b.BoothNo);
                if (aName < bName) {
                  return -1;
                }
                if (aName > bName) {
                  return 1;
                }
                return 0;
              });
            } else {
              self.Exhibitorlist.sort(function (a, b) {
                let aName = a.Name.trim().toLowerCase();
                let bName = b.Name.trim().toLowerCase();
                if (aName < bName) {
                  return -1;
                }
                if (aName > bName) {
                  return 1;
                }
                return 0;
              });
            }

            this.totalCount = self.Exhibitorlist.length;
            store.commit("addExpoBoothCount", this.totalCount);
            this.stRange = 0;
            this.endRange = 7;
            if (this.endRange > this.totalCount) {
              this.endRange = this.totalCount;
            }
            store.commit("addExbList", id.substring(0, id.length - 1));
            var exhibitorIds2 = "";
            self.Exhibitorlist.map((item) => {
              exhibitorIds2 += item.id + ",";
            });

            if (exhibitorIds2 != "") {
              exhibitorIds2 = exhibitorIds2.substring(
                0,
                exhibitorIds2.length - 1
              );
            }
            store.commit("addExbList", exhibitorIds2);
            if (this.totalCount == 1) {
              this.loadView(
                self.Exhibitorlist[0].id,
                self.Exhibitorlist[0].Name
              );
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    loadhotspotterscripts: function () {
      let externalScript = document.createElement("script");
      externalScript.setAttribute(
        // "src",
        // "https://ajax.googleapis.com/ajax/libs/jquery/1.8.3/jquery.min.js"
        "src",
        "https://ajax.googleapis.com/ajax/libs/jqueryui/1.12.1/jquery-ui.min.js"
      );
      externalScript.setAttribute("type", "text/javascript");
      document.body.appendChild(externalScript);

      let externalScript1 = document.createElement("script");
      externalScript1.setAttribute(
        // "type",
        // "https://ajax.googleapis.com/ajax/libs/jqueryui/1.9.2/jquery-ui.min.js"
        "type",
        "https://ajax.googleapis.com/ajax/libs/jqueryui/1.12.1/jquery-ui.min.js"
      );
      externalScript1.setAttribute("type", "text/javascript");
      document.body.appendChild(externalScript1);

      let externalScript3 = document.createElement("script");
      externalScript3.setAttribute(
        "src",
        "https://resources.e2m.live/e2monair.appspot.com/Hotspotter%2Fjs%2Fjquery-hotspotter.js?alt=media"
      );
      externalScript3.setAttribute("type", "text/javascript");
      document.body.appendChild(externalScript3);

      let externalScript4 = document.createElement("script");
      externalScript4.setAttribute(
        "src",
        "https://resources.e2m.live/e2monair.appspot.com/Hotspotter%2Fjs%2Fjquery-hotspotter.min.js?alt=media"
      );
      externalScript4.setAttribute("type", "text/javascript");
      document.body.appendChild(externalScript4);

      let externalScript5 = document.createElement("script");
      externalScript5.setAttribute(
        "src",
        "https://resources.e2m.live/e2monair.appspot.com/Hotspotter%2Fjs%2Fother.js?alt=media"
      );
      externalScript5.setAttribute("type", "text/javascript");
      document.body.appendChild(externalScript5);
    },
    getPrvLot: function () {
      this.show = false;
      this.transitionType = null;
      this.transitionType = "slide-right";
      this.stRange = parseInt(this.stRange) - 7;
      if (this.stRange <= 0) {
        this.stRange = 0;
      }

      this.endRange = parseInt(this.endRange) - 7;
      if (this.endRange >= this.totalCount) {
        this.endRange = this.totalCount;
      }
      if (this.endRange % 7 !== 0) {
        this.endRange = parseInt(this.endRange) + (7 - (this.endRange % 7));
      }
      setTimeout(() => {
        this.show = true;
      }, 500);
      // this.$nextTick(() => {
      //   this.show = true;
      // });
    },
    getNextLot: function () {
      this.show = false;
      this.transitionType = "slide-left";
      this.stRange = parseInt(this.stRange) + 7;

      this.endRange = parseInt(this.endRange) + 7;

      if (this.endRange > this.totalCount) {
        this.endRange = this.totalCount;
      }
      setTimeout(() => {
        this.show = true;
      }, 500);
      // this.$nextTick(() => {
      //   this.show = true;
      // });
    },
    loadView(id, name) {
      store.commit("addExhibitorID", id);
      var url = "exhibitorsview/" + id + "/" + name.replace(/%20/g, "_");
      router.push(url.replace(/ /g, "_"));
    },
    cancelSearch: function () {
      self.IsSearchMode = false;
      self.IsShowNoDataFound = false;
      self.IsShowCancelButton = false;
      self.pageSize = 100;
      self.pageIndex = 0;
      self.totalRecords = 1;
      self.attendeeData = [];
      self.searchtext = "";
      self.Exhibitorlist = [];
      self.getExhibitors();
    },
    searchExhibitors2: function () {
      if (self.searchtext !== "") {
        self.totalRecords = 1;
        self.firstPageCalled = false;
        self.pageIndex = 0;
        self.hasMore = true;
        self.lastVisible = null;
        self.Exhibitorlist = [];
        self.getExhibitors();
      } else {
        self.lastVisible = null;
        self.Exhibitorlist = [];
        self.getExhibitors();
      }
    },
    searchExhibitors: function () {
      self.totalRecords = 1;
      self.firstPageCalled = false;
      self.pageIndex = 0;
      self.hasMore = true;
      self.lastVisible = null;
      self.Exhibitorlist = [];
      self.getExhibitors();
    },
    getSettings: function () {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      db.collection(obj.eventcollectionname)
        .doc("Settings")
        .collection("Exhibitor")
        .doc("ExhibitorSettings")
        .get()
        .then((doc) => {
          if (doc.exists) {
            let data = doc.data();
            if (data.AllowRequestMeetingInExpoHall) {
              self.allowRequestMeetingInExpoHall =
                data.AllowRequestMeetingInExpoHall;
            }
            if (data.ExpoHallBackgroundImage !== undefined) {
              if (data.ExpoHallBackgroundImage !== "") {
                self.ExpoHallDefaultBackgroundImage = self.getCDNUrl(
                  data.ExpoHallBackgroundImage
                );
              } else {
                self.ExpoHallDefaultBackgroundImage =
                  "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FSymposium%20Exhibitor%20Booth%2Fexpo-bg.jpg?alt=media&token=3eb488b8-32fd-4fae-8d49-b35a4e9a3ded";
              }
            } else {
              self.ExpoHallDefaultBackgroundImage =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FSymposium%20Exhibitor%20Booth%2Fexpo-bg.jpg?alt=media&token=3eb488b8-32fd-4fae-8d49-b35a4e9a3ded";
            }
            self.ExpoHallBackgroundImage = self.ExpoHallDefaultBackgroundImage;

            if (data.EnableExhibitorFilterAndSearchOption == false) {
              if (document.getElementById("dvFilter") !== undefined) {
                if (document.getElementById("dvFilter") !== null) {
                  //console.log('hi');
                  document.getElementById("dvFilter").style.visibility =
                    "hidden";
                }
              }
            }
            if (data.IsExpoAlertEnabled == true) {
              self.showTooltips = true;
            } else {
              self.showTooltips = false;
            }

            if (data.OrderBy) {
              self.orderBy = data.OrderBy;
            } else {
              self.orderBy = "BoothNo";
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    ExpoClick: function () {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj.eventcollectionname !== undefined) {
        if (obj.eventcollectionname !== "") {
          db.collection(obj.eventcollectionname)
            .doc("Settings")
            .collection("Exhibitor")
            .doc("ExhibitorSettings")
            .get()
            .then((doc) => {
              if (doc.exists) {
                let data = doc.data();
                if (data.EnableEnhancedExpoMode === true) {
                  store.commit("setAdvExpo", true);
                  $(".page-effect").show();
                } else {
                  store.commit("setAdvExpo", false);
                  router.push("/exhibitor");
                }
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }
    },
    selectExpoMenu: function () {
      $("#liexhibitor")
        .find("a:first")
        .addClass("router-link-exact-active router-link-active");
      //$("#liexhibitor").first().addClass("active");
    },
    removeSelection: function () {
      $("#liexhibitor")
        .find("a:first")
        .removeClass("router-link-exact-active router-link-active");
    },
    getExpoBackground: function () {},
    closeHandler() {
      self.dialog = false;
    },
    openSchedulePopup(routeVal) {
      //alert(self.visitor);
      if (self.visitor) {
        common.openRegistrationDialog();
        return;
      }
      //routeVal = "/mymeetings";
      console.log(routeVal);
      //routeVal = "/livestage/1111_o2o";
      //if (!routeVal) {
      //  routeVal = "/mymeetings";
      //}
      if (routeVal) {
        //this.$router.replace("/exhibitorshall" + routeVal);
      }
      self.dialog = true;
    },
    routerHandler: function (routeVal) {
      if (routeVal.includes("http")) {
        window.open(routeVal);
      }
      // else if (routeVal.includes("profile")) {
      //   this.profileView = true;
      // }
      else {
        this.$router.replace("/mainlobby" + routeVal);
        this.dialog = true;
      }
      console.log(routeVal);
    },
    goToBookAppointment() {
      //alert("E goToBookAppointment");
      //$("#tabExhibitorsSchedule").click();
      self.tab = "schedule";
    },
    OpenRequestMeeting(data) {
      self.requestMeetingKey++;
      self.currentAttendee = data;
      console.log("data=====", data);
      //if (data.ProfilePictureURL != "") {
      //  var AttendeeImgPath = data.ProfilePictureURL;

      //  if (
      //    AttendeeImgPath != null &&
      //    AttendeeImgPath != "" &&
      //    document.getElementById("ReqAttendeeImage")
      //  ) {
      //    document.getElementById("ReqAttendeeImage").src = AttendeeImgPath;
      //    $("#ReqAttendeeImage").show();
      //  }

      //  if (document.getElementById("ReqdivImgHldText")) {
      //    document.getElementById("ReqdivImgHldText").innerText = "";
      //    $("#ReqdivImgHldText").hide();
      //  }
      //} else {
      //  var Initials = "";
      //  if (document.getElementById("dvImgeHldText")) {
      //    Initials = document.getElementById("dvImgeHldText").innerText;
      //  }
      //  if ($("#ReqAttendeeImage")) {
      //    $("#ReqAttendeeImage").attr("src", "");
      //    $("#ReqAttendeeImage").hide();
      //  }
      //  if (document.getElementById("ReqdivImgHldText")) {
      //    document.getElementById("ReqdivImgHldText").innerHTML =
      //      "<h4>" + Initials + "</h4>";
      //    $("#ReqdivImgHldText").show();
      //  }
      //}

      //if (document.getElementById("ReqAttendeeName")) {
      //  document.getElementById("ReqAttendeeName").innerText = data.Name;
      //}
      //if (document.getElementById("ReqAttendeeNameh4")) {
      //  document.getElementById("ReqAttendeeNameh4").innerText = data.Name;
      //}
      //if (document.getElementById("ReqAttendeeTitle")) {
      //  document.getElementById("ReqAttendeeTitle").innerText =
      //    data.Designation;
      //}
      //if (document.getElementById("ReqAttendeeCompany")) {
      //  document.getElementById("ReqAttendeeCompany").innerText = data.Company;
      //}
      //if (data.Email) {
      //  if (document.getElementById("ReqAttendeeEmail")) {
      //    document.getElementById("ReqAttendeeEmail").href = data.Email;
      //    if (
      //      document.getElementById("ReqAttendeeEmail").href.indexOf("mailto") <
      //      0
      //    ) {
      //      $("#ReqAttendeeEmail").text(data.Email);
      //      document.getElementById("ReqAttendeeEmail").href =
      //        "mailto:" + document.getElementById("ReqAttendeeEmail").href;
      //    }
      //    $("#ReqAttendeeEmail").parent().show();
      //  } else {
      //    $("#ReqAttendeeEmail").parent().hide();
      //  }
      //} else {
      //  $("#ReqAttendeeEmail").parent().hide();
      //}

      //if (data.Phone) {
      //  if (document.getElementById("ReqAttendeePhone")) {
      //    document.getElementById("ReqAttendeePhone").href = data.Phone;
      //    if (
      //      document.getElementById("ReqAttendeePhone").href.indexOf("tel") < 0
      //    ) {
      //      $("#ReqAttendeePhone").text(data.Phone);
      //      document.getElementById("ReqAttendeePhone").href =
      //        "tel:" + document.getElementById("ReqAttendeePhone").href;
      //    }
      //    $("#ReqAttendeePhone").parent().show();
      //  } else {
      //    $("#ReqAttendeePhone").parent().hide();
      //  }
      //} else {
      //  $("#ReqAttendeePhone").parent().hide();
      //}
      //if ($("#ReqAttendeeWebsite")) {
      //  $("#ReqAttendeeWebsite").parent().hide();
      //}
      $("#aFacebok").hide();
      $("#aTwitter").hide();
      $("#aLikedin").hide();
      $("#hdnAttendeeId").val(data.AttendeeId);
      var hdnattendeeId = data.AttendeeId;
      var ComponentClass = Vue.extend(RequestMeeting);
      var instance = new ComponentClass({
        propsData: {
          attendeeId: hdnattendeeId,
          showDatePicker: true,
          attendee: data,
        },
      });
      instance.$mount();

      $("#myModal2").hide();
      $(".modal-backdrop").hide();
    },
  },
};
</script>
